
import { throwError as observableThrowError, Observable } from 'rxjs';

import { catchError, map } from 'rxjs/operators';
/**
 * Service FileService
 */
import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import * as Rx from 'rxjs';

import { HttpClientService } from './httpClient.service';

import * as _ from 'lodash';

@Injectable()
export class FileService {
  private _baseURL = "/api/files/";

  constructor(private _http: HttpClientService, private _httpPublic: HttpClient) {

  }

  lock(id) {
    let url = this._baseURL + id + '/lock';

    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    //noinspection TypeScriptValidateTypes
    return this._http.put(url, '', headers).pipe(
      map(res => res),
      catchError(this._handleError));
  }

  unlock(id) {
    let url = this._baseURL + id + '/unlock';

    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    //noinspection TypeScriptValidateTypes
    return this._http.put(url, '', headers).pipe(
      map(res => res),
      catchError(this._handleError));
  }

  unlink(id) {
    let url = this._baseURL + id + '/unlink';

    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    //noinspection TypeScriptValidateTypes
    return this._http.put(url, '', headers).pipe(
      map(res => res),
      catchError(this._handleError));
  }

  getFromPID(pid) {
    let url = this._baseURL + "pid/" + pid;

    //noinspection TypeScriptValidateTypes
    return this._http.get(url).pipe(
      map(res => res),
      catchError(this._handleError));
  }

  addFile(pid, data, subpid = null) {
    let url = this._baseURL + "pid/" + pid;

    if (subpid && pid != subpid) {
      url += '/' + subpid;
    }
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    //noinspection TypeScriptValidateTypes
    return this._http.post(url, JSON.stringify(data), headers).pipe(
      map(res => res),
      catchError(this._handleError));
  }

  getFileInformation(fileId, pid) {
    let url = this._baseURL + fileId + '/all/' + pid;

    //noinspection TypeScriptValidateTypes
    return this._http.get(url).pipe(
      map(res => res),
      catchError(this._handleError));
  }

  getFileLinkStats(fileId) {
    let url = this._baseURL + fileId + '/linkstats';

    //noinspection TypeScriptValidateTypes
    return this._http.get(url).pipe(
      map(res => res),
      catchError(this._handleError));
  }

  getFileURL(pid, file) {
    let url = this._baseURL + "pid/" + pid + "/" + file._id;

    //noinspection TypeScriptValidateTypes
    return this._http.get(url).pipe(
      map(res => res),
      catchError(this._handleError));
  }


  getFileVersionURL(pid, file, version) {
    let url = this._baseURL + "pid/" + pid + "/" + file._id + '/' + version;
    console.log("request file version url", version);
    //noinspection TypeScriptValidateTypes
    return this._http.get(url).pipe(
      map(res => res),
      catchError(this._handleError));
  }

  getContractorFileURL(pid, file, token, version = null) {
    console.log("getContractorFileURL", pid, file._id, token);
    let url = this._baseURL + "pid/" + pid + "/" + file._id + '/token/' + token;
    if (version) {
      url += '/version/' + version;
    }

    //noinspection TypeScriptValidateTypes
    return this._http.get(url).pipe(
      map(res => res),
      catchError(this._handleError));
  }


  getContractorFiles(file, token) {
    let url = this._baseURL + file._id + '/contractor/' + token;

    //noinspection TypeScriptValidateTypes
    return this._http.get(url).pipe(
      map(res => res),
      catchError(this._handleError));
  }



  getViewFileURL(pid, file, token, subpid = null) {
    let url = this._baseURL + "pid/" + pid + "/" + file._id + '/token/' + token + '/view';

    if (subpid) {
      url += '/' + subpid;
    }

    //noinspection TypeScriptValidateTypes
    return this._httpPublic.get(url).pipe(
      map(res => res),
      catchError(this._handleError));
  }

  getOriginalFileVersion(pid, file, versionId = null) {
    let url = '';
    if (versionId) {
      url = this._baseURL + "pid/" + pid + "/" + file._id + "/" + versionId;
    } else {
      url = this._baseURL + "pid/" + pid + "/" + file._id + "/original";
    }

    //noinspection TypeScriptValidateTypes
    return this._http.get(url).pipe(
      map(res => res),
      catchError(this._handleError));
  }

  getPublicInformation(id, subpid = null) {
    if (!subpid) {
      var url = this._baseURL + id;
    } else {
      var url = this._baseURL + id + '/pid/' + subpid;
    }

    //noinspection TypeScriptValidateTypes
    return this._httpPublic.get(url).pipe(
      map(res => res),
      catchError(this._handleError));
  }

  getPutUrl(token, id, files, pid = null) {
    let url = this._baseURL + id + '/putUrl/' + token;

    if (pid) {
      url += '/pid/' + pid;
    }

    url += '?files=' + JSON.stringify(_.map(files, file => {
      return { name: encodeURIComponent(file['name']), type: file['type'] };
    }));
    //noinspection TypeScriptValidateTypes
    return this._httpPublic.get(url).pipe(
      map((res: any) => res.urls),
      catchError(this._handleError));
  }

  getPutToken(token, id) {
    let url = this._baseURL + id + "/putToken/" + token;

    //noinspection TypeScriptValidateTypes
    return this._httpPublic.get(url).pipe(
      map((res: any) => res.token),
      catchError(this._handleError));
  }

  convertToPDF(id) {
    let url = this._baseURL + id + "/uploaded";

    //noinspection TypeScriptValidateTypes
    return this._httpPublic.get(url).pipe(
      map(res => res),
      catchError(this._handleError));
  }

  convertibleTypes = {
    'application': [
      'msword', //doc
      'vnd.openxmlformats-officedocument.wordprocessingml.document', //docx
      'vnd.ms-excel', //xls
      'vnd.openxmlformats-officedocument.spreadsheetml.sheet', //xlsx
      'vnd.ms-powerpoint', //ppt
      'vnd.openxmlformats-officedocument.presentationml.presentation' //pptx
    ],
    'text': [
      'plain',
      'html', //Avoid html injection in preview
      'csv'
    ]
  };

  displayVersionsOnly(versions) {
    if (versions.length > 1) {

      versions = versions.filter(x => {

        var needForConversion = x.files.filter(y => {
          let needsConversion = false;
          //console.log("check", y, y.fileType);
          let parts = y.fileType && y.fileType.split('/');
          if (parts && this.convertibleTypes[parts[0]]) {
            needsConversion = this.convertibleTypes[parts[0]].indexOf(parts[1]) > -1;
          }
          return needsConversion;
        })
        return needForConversion.length == 0;
      });
    }

    return versions;
  }

  needToConvert(filetype) {
    return (this.convertibleTypes[filetype[0]] && this.convertibleTypes[filetype[0]].indexOf(filetype[1]) >= 0);
  }

  logUpload(fileInfo, fileId, success, authenticated = true) {
    let url = this._baseURL + fileId;
    if (authenticated){
      url += "/logupload";
    } else {
      url += "/loguploadcontractor";
    }
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    console.log("log upload", fileInfo, fileId, success, url, authenticated);
    //noinspection TypeScriptValidateTypes
    return this._http.put(url, JSON.stringify({ fileInfo: {}, success: success }), headers).pipe(
      map(res => res),
      catchError(this._handleError));
  }

  uploadTo(url, fileInfo, fileId, authenticated = true) {
    var me = this;
    return new Rx.Observable(obs => {
      var xhr = new XMLHttpRequest();
      xhr.open("PUT", url);
      xhr.onload = function () {
        if (xhr.status === 200) {
          obs.next("Success");
          obs.complete();
          me.logUpload(fileInfo, fileId, true, authenticated).subscribe(
            ret => {
            });
        } else {
          obs.error("Could not upload file.");
          me.logUpload(fileInfo, fileId, false, authenticated).subscribe(
            ret => {
            });
        }
      };
      xhr.onerror = function () {
        obs.error("Could not upload file.");
        me.logUpload(fileInfo, fileId, false, authenticated).subscribe(
          ret => {
          });
      };
      xhr.send(fileInfo);
    });
  }

  editFile(fileToEdit, filesToUpload) {
    let url = this._baseURL + fileToEdit._id + '/putUrl/?files=' + JSON.stringify(_.map(filesToUpload, file => {
      return { name: encodeURIComponent(file['name']), type: file['type'] };
    }));
    //noinspection TypeScriptValidateTypes
    return this._http.get(url).pipe(
      map((res: any) => res.urls),
      catchError(this._handleError));
  }

  private _handleError(error) {
    // in a real world app, we may send the error to some remote logging infrastructure
    // instead of just logging it to the console
    return observableThrowError(error['message'] || error['_body'] || 'Server error');
  }

  getForTransferredPID(pid) {
    let url = this._baseURL + "transferred/" + pid;

    //noinspection TypeScriptValidateTypes
    return this._http.get(url).pipe(
      map(res => res),
      catchError(this._handleError));
  }

  deleteFile(pid, fileId) {
    console.log("delete file", pid, fileId);
    let url = this._baseURL + "pid/" + pid + "/" + fileId;

    //noinspection TypeScriptValidateTypes
    return this._http.delete(url).pipe(
      catchError(this._handleError));
  }

  deleteFileVersion(pidId, fileId, versionId) {
    let url = this._baseURL + "pid/" + pidId + "/" + fileId + '/' + versionId;

    //noinspection TypeScriptValidateTypes
    return this._http.delete(url).pipe(
      catchError(this._handleError));
  }


  updateContractor(contractor) {

  }

  initLink(pid, fileId, email, subPID = null) {
    let url = this._baseURL + pid + "/" + fileId + "/linkto";
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    //noinspection TypeScriptValidateTypes
    return this._http.put(url, JSON.stringify({ email: email, pid: subPID || pid }), headers).pipe(
      map(res => res),
      catchError(this._handleError));
  }

  update(pid, fileId, data, sendmail = 1) {
    let url = this._baseURL + pid + "/" + fileId + "/update/" + sendmail.toString();
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    return this._http.put(url, JSON.stringify(data), headers);
  }


}
